import { FC, PropsWithChildren, useEffect } from 'react'
import { useCurrentPatient } from 'src/common/api'

export const RequirePatientAuth: FC<PropsWithChildren> = ({ children }) => {
  const { isFetched, isError, data: patient } = useCurrentPatient()

  useEffect(() => {
    if (isFetched && !patient) {
      history.replaceState(null, 'HealthHelper', '/auth/link/resend')
      location.reload()
    }
  }, [patient, isFetched])

  useEffect(() => {
    if (isError) {
      history.replaceState(null, 'HealthHelper', '/auth/link/resend')
      location.reload()
    }
  }, [isError])

  if (!isFetched) {
    return null
  }

  return <>{children}</>
}
